import * as aboutUs from './aboutUs/actions';
import * as contactUs from './contactUs/actions';
import * as faq from './faq/actions';
import * as forms from './forms/actions';
import * as news from './news/actions';
import * as home from './home/actions';
import * as rateArchive from './rateArchive/actions';
import * as reception from './reception/actions';
import * as services from './services/actions';
import * as survey from './survey/actions';
//
import * as adminNews from './adminNews/actions';
import * as adminEvent from './adminEvent/actions';
import * as adminSetting from './adminSetting/actions';
import * as adminReception from './adminReception/actions';
import * as adminScreen from './adminScreen/actions';

export const pageActions = {
	//
	aboutUs,
	contactUs,
	faq,
	forms,
	news,
	home,
	rateArchive,
	reception,
	services,
	survey,
	//
	adminNews,
	adminEvent,
	adminSetting,
	adminReception,
	adminScreen,
};
